import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSE: CultureInfo = {
  name: 'en-SE',
  displayName: 'English (Sweden)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SE',
  parent: CultureInfoEn
};
